import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from 'react';
import GameModeModal from '../Components/GameModeModal';

export type PlayModalContextValue = {
  showPlayModal: boolean;
  openPlayModal: () => void;
  closePlayModal: () => void;
};

export const PlayModalContext = createContext<PlayModalContextValue>({
  showPlayModal: false,
  openPlayModal: () => {},
  closePlayModal: () => {},
});

export const usePlayModalContext = () => useContext(PlayModalContext);

export default function PlayModalProvider({ children }: { children: ReactNode }) {
  const [showPlayModal, setShowPlayModal] = useState(false);
  const [modalReady, setModalReady] = useState(false);

  const openPlayModal = useCallback(() => {
    setModalReady(true);
    setShowPlayModal(true);
  }, []);
  const closePlayModal = useCallback(() => setShowPlayModal(false), []);

  const value = useMemo(
    () => ({ showPlayModal, openPlayModal, closePlayModal }),
    [showPlayModal, openPlayModal, closePlayModal]
  );

  return (
    <PlayModalContext.Provider value={value}>
      {children}
      {modalReady ? <GameModeModal show={showPlayModal} onClose={closePlayModal} /> : null}
    </PlayModalContext.Provider>
  );
}
